

















import { useStampStore } from '@/store/stamp';
import { defineComponent, computed, ref } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import NgoStampNgoItem from './ngo-item.vue';
import ExchangeDialog from './exchange-dialog.vue';
import { ScreenDialog } from '@tencent/wphk-ui';
import { useDonation } from '@/hooks/use-donation';

export default defineComponent({
  name: 'NgoStampNgo',
  components: { NgoStampNgoItem, ExchangeDialog },
  setup() {
    const stampStore = useStampStore(); // store
    const { ngoActInfoList } = storeToRefs(stampStore);
    const ngoActInfoListVal = computed(() => ngoActInfoList.value); // NGO 活动信息

    // 捐贈成功弹窗
    const currentDonateNGO = ref({});
    const exchangeDialog = ref<InstanceType<typeof ScreenDialog> | null>(null);
    const handleShowExchangeDialog = (ngo) => {
      currentDonateNGO.value = ngo;
      exchangeDialog.value?.show();
    };

    // 用户当前捐贈状态
    const { userDonationStatus } = useDonation();

    return {
      ngoActInfoListVal,
      exchangeDialog,
      handleShowExchangeDialog,
      currentDonateNGO,
      userDonationStatus,
    };
  },
});
